(function fadeIn() {
  const callback = function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("motion-safe:animate-fadeIn");
      }
    });
  };
  const observer = new IntersectionObserver(callback);
  const targets = document.querySelectorAll('[data-fade-in]');
  if (targets.length > 0) {
    targets.forEach(function(target) {
      observer.observe(target);
    });
  }
})();

var notifyModal = document.querySelector('[data-notify-modal]');
if (notifyModal) {
  const notifySuccess = notifyModal.querySelector('[data-notify-success]');
  document.addEventListener('keydown', function(e) {
    if (e.key == 'Escape') {
      notifyModal.classList.add('hidden');
      notifySuccess.classList.add('hidden');
    }
  })
  document.querySelector('[data-close-notify]').addEventListener('click', function() {
    notifyModal.classList.add('hidden');
    notifySuccess.classList.add('hidden');
  });
  document.querySelector('[data-notify-trigger]').addEventListener('click', function() {
    notifyModal.classList.remove('hidden');
  });
  document.querySelector('[data-notify-form]').addEventListener('submit', event => {
    event.preventDefault();
    const email = event.target.elements.email.value;
    const variantId = event.target.elements.notify_variant.value;
    const data = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              // id: '01GDDKASAP8TKDDA2GRZDSVP4H',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    };
    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.df_api.vendor.klaviyo.publicApiKey}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-06-15',
        'accept': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => {
      return response.text()
    })
    .then(response => {
      event.target.reset();
      notifySuccess.classList.remove('hidden');
    })
    .catch(err => console.error(err));
  });
}

class FibblModel extends HTMLElement {

  constructor() {
    super();
    this.active = this.getAttribute('active');
    if (this.active !== 'true') return;
    this.model = this.querySelector('[data-model]');
    this.arButtonText = document.querySelectorAll('[data-ar-button]');
    this.arToggleButtons = this.querySelectorAll('[data-ar-toggle]');
    this.arToggleButtons.forEach(button => button.addEventListener('click', this.handleToggleAr.bind(this)));
    this.modelToggleButtons = this.querySelectorAll('[data-model-toggle]');
    this.imagesToggle = this.querySelector('[data-element="default"][data-ar-toggle]');
    this.imagesToggle.addEventListener('click', this.handleImagesToggle.bind(this));
    this.modelToggleButtons.forEach(button => button.addEventListener('click', this.handleToggleView.bind(this)));
    // this.initArButtonText();
  }
  
  initArButtonText() {
    const component = this;
    setTimeout(() => {
      component.arButtonText.forEach(button => {
        button.classList.toggle('active');
      });
      component.initArButtonText();
    }, 2500);
  }

  handleImagesToggle() {
    this.modelToggleButtons.forEach(button => {
      if (button.dataset.modelToggle === 'default') {
        button.classList.add('active');
      } else {
        button.classList.remove('active')
      }
    }); 
  }

  handleToggleAr(event) {
    this.arToggleButtons.forEach(button => button.classList.add('visible'));
    event.target.classList.remove('visible');
  }

  handleToggleView(event) {
    this.modelToggleButtons.forEach(button => button.classList.remove('active')); 
    event.target.classList.add('active');
  }

}
customElements.define('ar-model', FibblModel);